import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { LightboxModule } from 'ngx-lightbox';
import { NgOptimizedImage } from '@angular/common'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home.component';
import { FeaturesComponent } from './features.component';
import { PricingComponent } from './pricing.component';
import { GuideComponent } from './guide.component';
import { FooterComponent } from './footer.component';
import { GalleryScrollDirective } from './gallery-scroll.directive';
import { RevealDirective } from './reveal.directive';
import { HeroComponent } from './hero/hero.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { DashEnterpriseAuthComponent } from './dash-enterprise-auth/dash-enterprise-auth.component';
import { GuideO365PowershellComponent } from './guide-o365-powershell/guide-o365-powershell.component';
import { GuideO365ServiceAccountComponent } from './guide-o365-service-account/guide-o365-service-account.component';
import { GuideGoogleComponent } from './guide-google/guide-google.component';
import { GuideGooglePersonalAccountComponent } from './guide-google-personal-account/guide-google-personal-account.component';
import { GuideGoogleServiceAccountComponent } from './guide-google-service-account/guide-google-service-account.component';
import { GuideO365Component } from './guide-o365/guide-o365.component';
import { GuideO365EnterpriseApplicationComponent } from './guide-o365-enterprise-application/guide-o365-enterprise-application.component';
import { GuideEnterpriseComponent } from './enterprise/guide-enterprise/guide-enterprise.component';
import { GuideEnterpriseDashboardComponent } from './enterprise/guide-enterprise-dashboard/guide-enterprise-dashboard.component';
import { GuideEnterpriseMdmComponent } from './enterprise/guide-enterprise-mdm/guide-enterprise-mdm.component';
import { GuideEnterpriseDashboardConfigurationComponent } from './enterprise/guide-enterprise-dashboard-configuration/guide-enterprise-dashboard-configuration.component';
import { EnterpriseTabNavigatorComponent } from './enterprise/enterprise-tab-navigator/enterprise-tab-navigator.component';
import { EnterpriseConfigurationValuesComponent } from './enterprise/enterprise-configuration-values/enterprise-configuration-values.component';
import { GuideEnterpriseAnalyticsComponent } from './enterprise/guide-enterprise-analytics/guide-enterprise-analytics.component';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';
import { DataDeletionComponent } from './data-deletion/data-deletion.component';
import { GuideEnterpriseUserAdministrationComponent } from './enterprise/guide-enterprise-user-administration/guide-enterprise-user-administration.component';
import { HardwareComponent } from './hardware/hardware.component';
import { GuideEnterpriseWebComponent } from './enterprise/guide-enterprise-web/guide-enterprise-web.component';
import { IllustrationComponent } from './illustration/illustration.component';
import { SlideshowComponent } from './slideshow/slideshow.component';
import { SlideComponent } from './slideshow/slide.component';
import { AboutEnterpriseComponent } from './about-enterprise/about-enterprise.component';
import { BlogIndexComponent } from './blog/blog-index.component';
import { BlogPostComponent } from './blog/blog-post.component';
// import { GuideIosComponent } from './guide-ios/guide-ios.component';
// import { GuideAndroidComponent } from './guide-android/guide-android.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FeaturesComponent,
    PricingComponent,
    GuideComponent,
    FooterComponent,
    GalleryScrollDirective,
    RevealDirective,
    HeroComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    DashEnterpriseAuthComponent,
    GuideO365PowershellComponent,
    GuideO365ServiceAccountComponent,
    GuideGoogleComponent,
    GuideGooglePersonalAccountComponent,
    GuideGoogleServiceAccountComponent,
    GuideO365Component,
    GuideO365EnterpriseApplicationComponent,
    GuideEnterpriseComponent,
    GuideEnterpriseDashboardComponent,
    GuideEnterpriseMdmComponent,
    GuideEnterpriseDashboardConfigurationComponent,
    GuideEnterpriseAnalyticsComponent,
    EnterpriseTabNavigatorComponent,
    EnterpriseConfigurationValuesComponent,
    ThumbnailComponent,
    DataDeletionComponent,
    GuideEnterpriseUserAdministrationComponent,
    HardwareComponent,
    GuideEnterpriseWebComponent,
    IllustrationComponent,
    SlideshowComponent,
    SlideComponent,
    AboutEnterpriseComponent,
    BlogIndexComponent,
    BlogPostComponent,
    // GuideIosComponent,
    // GuideAndroidComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    LightboxModule,
    NgOptimizedImage,
  ],
  providers: [
    provideClientHydration(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
